import { NgModule } from '@angular/core';
import {CheckboxSliderComponent} from './checkbox-slider.component';

@NgModule({
  declarations: [CheckboxSliderComponent],
  imports: [
  ],
  exports: [CheckboxSliderComponent]
})
export class UiCheckboxSliderModule { }
